// src/config/teacherResourceCategories.js
// Preset category chips for the Teacher Resource library. Admins can also add
// free-form custom categories per file.
export const PREFERRED_CATEGORIES = [
  { id: 'meeting-backgrounds', label: 'Meeting Backgrounds' },
  { id: 'teaching-aids', label: 'Teaching Aids' },
  { id: 'policies', label: 'Policies' },
];
